






























































































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from 'vuex-class';
import { SFInput, ProgressFooter, SFTextarea } from '@/components';
import t from '@/i18n/translations';
import { required, numeric, minValue, maxValue} from 'vuelidate/lib/validators';
import moment from 'moment';
import numeral from 'numeral';
import jwtDecode from 'jwt-decode';
import { toDate, isValid, isBefore } from 'date-fns';

const formNamespace = { namespace: 'form'};
const progressNamespace = { namespace: 'progress' };
const ns_user = { namespace: 'user' };

const commaSeparated = (val:any) => {
    return /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(val)
};
const greaterThanZero = (value) => value >= 0

@Component({
    components: {
        SFInput,
        ProgressFooter,
        SFTextarea
    },
    validations: {
        generalInformationAnswers: {
            referenceDateDebtorPortfolio: {
                required
            },
            borrowersName: { required },
            companyName: { },
            nominalCarryingAmountDebtorPortfolio: {
                required,
                numeric,
                minValue: minValue(1),
                maxValue: maxValue(100000000)
            },
            debiteurCreditorPositions: {
                numeric,
                minValue: greaterThanZero,
                maxValue: maxValue(100000000)
            },
            provisionForDebtors: {
                numeric,
                minValue: greaterThanZero,
                maxValue: maxValue(100000000)
            },
            pledgingProhibitions: {
                numeric,
                minValue: greaterThanZero,
                maxValue: maxValue(100000000)
            },
            nominalCarryingAmount: {
                numeric
            }
        }
    },
    filters: {
        formatNumber(value: any) {
            return numeral(value).format('0,0.[00]');
        }
    }
})
export default class ReportGeneralInformation extends Vue {
    @Action('logout', ns_user) logout: any;
    @Action('fetchUserInfo', ns_user) fetchUserInfo: any;

    @Getter('getGeneralInformationAnswers', formNamespace) getGeneralInformationAnswers: any;
    @Getter('getBranches', formNamespace) getBranches: any;
    @Getter('getToken', ns_user) getToken: any;
    @Getter('getUserInfo', ns_user) getUserInfo: any;

    @Mutation('toggleProgress', progressNamespace ) toggleProgress: any;
    @Mutation('setFormGeneralInformationAnswers', formNamespace ) setFormGeneralInformationAnswers: any;

    @Mutation('setStep1Unactive', progressNamespace) setStep1Unactive: any;
    @Mutation('setStep2Unactive', progressNamespace) setStep2Unactive: any;
    @Mutation('setStep3Unactive', progressNamespace) setStep3Unactive: any;

    @Mutation('setStep1Active', progressNamespace) setStep1Active: any;
    @Mutation('setStep2Active', progressNamespace) setStep2Active: any;
    @Mutation('setStep3Active', progressNamespace) setStep3Active: any;

    i18n = t['nl'];
    nominalQuote = 0;

    selectedBranchID: string = '';
    generalInformationAnswers: any = {
        referenceDateDebtorPortfolio: '',
        branchId: '',
        borrowersName: '',
        nominalCarryingAmountDebtorPortfolio: '',
        debiteurCreditorPositions: '',
        provisionForDebtors: '',
        pledgingProhibitions: '',
        nominalCarryingAmount: '',
        companyName: '',
        userComments: ''
    }
    isFormSubmitted: boolean = false;
    branchName: string = '';

    mounted(): void {
        this.appendValuesFromStore(this.generalInformationAnswers);
        this.selectedBranchID = this.$route.params.id;
        this.branchName = this.getBranches.filter((el:any) => el.id === this.$route.params.id)[0].name;
        this.generalInformationAnswers.branchId = this.$route.params.id;
        this.toggleProgress('generalInformation');
        this.countNominalQuote();
    }

    checkTokenAuth(token) {
        const expToken = jwtDecode(token).exp;
        const expDate = toDate(expToken * 1000);
        if (isValid(expDate) && isBefore(new Date(), expDate)) {
            return true;
        } else return false;
    }

    appendValuesFromStore(obj:any) {
        for (let name in obj) {
            this.generalInformationAnswers[name] = typeof(this.getGeneralInformationAnswers[name]) !== 'undefined' ? this.getGeneralInformationAnswers[name] : '';
        }
    }

    countNominalQuote() {
        const {
            nominalCarryingAmountDebtorPortfolio,
            debiteurCreditorPositions,
            provisionForDebtors,
            pledgingProhibitions
        } = this.generalInformationAnswers;

        const initialValue = nominalCarryingAmountDebtorPortfolio;
        const reduceCallback = (total, el) => total - el;
        const subFromParsed = (arrOfSubs:any) => arrOfSubs.reduce(reduceCallback, initialValue);

        this.nominalQuote = subFromParsed([debiteurCreditorPositions, provisionForDebtors, pledgingProhibitions]);
        this.generalInformationAnswers.nominalCarryingAmount = this.nominalQuote;
    }

    onInputChange(event:any, id: string) {
        if (id === "borrowersName" || id === "referenceDateDebtorPortfolio" || id === "userComments") {
            this.generalInformationAnswers[id] = event.target.value;
        } else {
            this.generalInformationAnswers[id] = parseFloat(event.target.value.replace(/,/g, ''));
            this.countNominalQuote();
        }

        this.setFormGeneralInformationAnswers(this.generalInformationAnswers);

        if(this.$v.$invalid) {
            this.setAllInactive();
        } else {
            this.setAllActive();
        }
    }

    setAllActive() {
        this.setStep1Active();
        this.setStep2Active();
    }

    setAllInactive() {
        this.setStep1Unactive();
        this.setStep2Unactive();
        this.setStep3Unactive();
    }

    onHandleSubmit() {
        const token = this.getToken;
        if (!this.checkTokenAuth(token)) (
            this.logout(),
            this.$router.push('/')
        );

        this.isFormSubmitted = true;
        this.$v.$touch();
    
        if(!this.$v.$invalid) {
            this.setAllActive();
            this.setFormGeneralInformationAnswers(this.generalInformationAnswers);
        } else {
            this.setAllInactive();
        }
    }
}
